import { ChangeDetectorRef, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AdminTabs } from '../../enum';
import { NavigationBase } from '../../navigation-base';
import { NavigationService } from '../../navigation.service';
import { EventBusService } from '../../../services/event-bus.service';

/**
 * Handles the admin navigation component
 */
@Component({
  selector: 'admin-navigation',
  templateUrl: './admin-navigation.component.html'
})
export class AdminNavigationComponent extends NavigationBase {
  /**
   * ChangeDetectorRef
   */
  _ref: ChangeDetectorRef;

  /**
   * Shows process template settings.
   */
  showProcessTemplateSettings: boolean;

  /**
   * Constructor
   * @param ref
   * @param navigationService
   * @param router
   */
  constructor(ref: ChangeDetectorRef,
    private navigationService: NavigationService,
    eventBus: EventBusService) {
    super(eventBus, ref);
    this._ref = ref;

    this.showProcessTemplateSettings = environment.showProcessTemplateSettings;
  }

  /**
  * Represents the selected tab in the admin section.
  */
  selectedTab: AdminTabs = AdminTabs.BusinessUnits;

  /**
   * Redirects to the specified tab in the admin section.
   * @param tab The tab to redirect to.
   */
  redirectTo(tab: string) {
    this.setSelectedTab(tab);
    this.eventBus.broadcastEvent('adminTabChanged', tab);

    // You can add further comments or explanations if needed.
  }

  /**
   * Returns the active tab in the admin section.
   */
  public get activeTab(): typeof AdminTabs {
    return AdminTabs;

    // You can add further comments or explanations if needed.
  }

  /**
   * Triggers the specified action.
   * @param action The action to trigger.
   */
  triggerAction(action: string) {
    this.eventBus.broadcastEvent(action);

    // You can add further comments or explanations if needed.
  }

  /**
   * Sets the selected tab based on the specified tab name.
   * @param tab The tab name.
   */
  private setSelectedTab(tab: string) {
    switch (tab) {
      case 'buManagement':
        this.selectedTab = AdminTabs.BusinessUnits;
        break;
      case 'userManagement':
        this.selectedTab = AdminTabs.Users;
        break;
      case 'managementroleManagement':
        this.selectedTab = AdminTabs.RoleManagment;
        break;
      case 'calcModels':
        this.selectedTab = AdminTabs.CalculationModel;
        break;
      case 'raciTemplate':
        this.selectedTab = AdminTabs.RaciTemplate;
        break;
      case 'localizationHost':
        this.selectedTab = AdminTabs.LocalizationHost;
        break;
    }

    this.navigationService.setActiveAdminTab(this.selectedTab);

    // You can add further comments or explanations if needed.
  }
}
